import "bootstrap/dist/css/bootstrap.min.css";
import AddUpdateForm from "../../../Components/AddUpdateForm";
import { Breadcrumb, Button } from "react-bootstrap";
import FieldDescription from "../../../Components/FieldDescription";
import { useState } from "react";
import { Ingredients } from "../../../Model/Setting/Ingredients";
import { useParams } from "react-router-dom";
interface AddUpdateProps {
  title?: any;
  listRoute?: any;
  isNotUpdate?: any;
  onChangeModalStatus?: (status: boolean) => void;
}

const AddUpdate: React.FC<AddUpdateProps> = ({
  title,
  listRoute,
  isNotUpdate,
  onChangeModalStatus,
}) => {
  const [isShows, setIsShows] = useState<boolean>(false);
  let { id }: any = useParams();
  const formFields = [
    {
      id: "inputName",
      label: "Name*",
      type: "text",
      col: 12,
      name: "name",
      placeholder: "Enter Name",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Name is required",
        },
      ],
      description: "Enter the name of the product ingredients.",
    },
  ];
  const handleHelpButtonClick = () => {
    setIsShows(!isShows);
    const formBottom = document.getElementById("form-bottom");
    if (formBottom) {
      formBottom.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/ingredients">Ingredients</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Ingredients" : "Edit Ingredients"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <span style={{ float: "inline-end" }}>
          <Button variant="outline-secondary" onClick={handleHelpButtonClick}>
            Need Help?
          </Button>
        </span>
        <AddUpdateForm
          formFields={formFields}
          model={Ingredients}
          title={title}
          listRoute={listRoute}
          autoUpdateField={true}
          isNotUpdate={isNotUpdate}
          onChangeModalStatus={onChangeModalStatus}
        />
      </div>
      <div id="form-bottom">
        <FieldDescription
          title={title}
          formFields={formFields}
          isShows={isShows}
        />
      </div>
    </>
  );
};

export default AddUpdate;
